'use strict';

import 'angular';

import buttonDirective from './button';

const MODULE_NAME = 'daupler.users.resetPassword';

var app = angular.module(MODULE_NAME, [
]);
app.directive('forgotPassword', buttonDirective);

export default MODULE_NAME;
